import {
  Component,
  OnInit
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoaderService } from '@app/core/services/loader/loader.service';
import { InksoftService } from '@app/shared/services/inksoft/inksoft.service';
import { ProductService } from '@app/shared/services/product/product.service';
import { NotificationService } from '@app/core/services/notification/notification.service';
import {
  FilterList,
  FilterModelStoreFront
} from '@app/shared/models/product';
import { environment } from '@env/environment';
import { FormGroup, FormBuilder } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
import { EncrDecrService } from '../../../../shared/services/encr-decr-service.service';
import { CryptoKeyValue } from '../../../../shared/constants';
import { ProductLibraryColorModel, ProductLibraryModel } from '@app/shared/models/customized-product.interface';
import { DesignHuddleImageService } from '@app/shared/services/design-huddle/design-huddle-image.service';
@Component({
  selector: 'app-viewstore',
  templateUrl: './viewstore.component.html',
  styleUrls: ['./viewstore.component.css']
})
export class ViewstoreComponent implements OnInit {
  mobileScreen: boolean = false;
  // For Infinite scroll of grid
  searchString: any;
  searchCustomizedForm!: FormGroup;
  // -------------------------
  customizedProducts: ProductLibraryModel[] = [];
  catListDB: any[] = [];
  imgBaseURL = environment.imgBaseURL;
  imgCustomBaseURL = environment.productCustomImageFolder;

  /** filtermodel holds filtering data to get filtered records from API */
  filterModel: FilterModelStoreFront = {
    Skip: 0,
    Take: 25,
    Size: [],
    Brand: [],
    Color: [],
    StoreName: '',
    Category: '',
    searchBy: '',
    Embroidery: true,
    ScreenPrint: true,
  };
  /** Filter list is for master filter list record */
  filterList: FilterList = {
    Categories: [],
    Brands: [],
    Colors: [],
    Sizes: []
  };
  productsCount = 0;
  storenameParam = localStorage.getItem('storeUrl');
  // ---------------------------------------------

  // Material paginator fields
  pageIndex = 0;
  pageSize = 25; // No of items to load from server side i.e no of items to take
  length = 0; // Total items count
  screenPrint: boolean = true;
  embroidery: boolean = true;


  // ---------------------------------------------
  constructor(
    private loader: LoaderService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private inksoftService: InksoftService,
    private notification: NotificationService,
    private productService: ProductService,
    private formBuilder: FormBuilder,
    private EncrDecr: EncrDecrService,
    private designHuddleImageService: DesignHuddleImageService
  ) {
    this.searchCustomizedForm = this.formBuilder.group({
      searchProduct: ['']
    });

  }

  ngOnInit() {
    this.mobileScreen = $(window).width() >= 768 ? false : true;
    this.initialize();
    localStorage.setItem('sampleOrder', '0')
    this.fn_GetSavedDesignListing();
    this.fn_GetFilters();
  }

  initialize() {
  }

  fn_GetFilters() {
    this.filterList.Categories = [];
    this.filterList.Brands = [];
    this.filterList.Colors = [];
    this.filterList.Sizes = [];
    this.loader.show();
    this.productService
      .getStorePublishProductMasterFiltersData(this.storenameParam)
      .subscribe(
        (res: any) => {
          if (res.Message === 'Success' || res.StatusCode === 200) {
            this.filterList.Categories = res.Data.Categories;
            this.filterList.Brands = res.Data.FilterModel.Brands;
            this.filterList.Colors = res.Data.FilterModel.Colors;
            this.filterList.Sizes = res.Data.FilterModel.Sizes;
          }
        },
        (err: any) => {
        }
      );
  }

  updateProductList(withResetProduct: any) {

    if (withResetProduct.reset) {
      this.fn_ResetProductList();
    }
    this.screenPrint = withResetProduct.screenPrint;
    this.embroidery = withResetProduct.embroidery;
    this.fn_GetSavedDesignListing();   
  }

  /**Functon to search */
  fn_searchCustomizeProduct(form: FormGroup) {
    this.filterModel.Skip = 0;
    this.customizedProducts = [];
    this.productsCount = 0;
    this.searchString = form.controls['searchProduct'].value;
    this.filterModel.searchBy = (this.fn_CheckForNullUndefinedEmptyString(this.searchString));
    this.fn_GetSavedDesignListing();
  }

  fn_GetPaginatedSavedDesignListing(event: PageEvent) {
    this.filterModel.Skip = event.pageIndex;
    this.pageIndex = event.pageIndex;
    this.filterModel.Take = event.pageSize;
    this.pageSize = event.pageSize;
    this.customizedProducts = [];
    this.productsCount = 0;
    this.fn_GetSavedDesignListing();
  }




  /** Resets product list */
  fn_ResetProductList() {
    this.customizedProducts = [];
    this.productsCount = 0;
  }
  displayColor(obj: any) {
    return {
      'background-color': obj
    };
  }
  selectStyleToCustomize(style: ProductLibraryColorModel, productIndex: any) {
    //let color = this.customizedProducts[productIndex].ColorList.find(x=>x.StyleId == style.StyleId);
    //this.customizedProducts[productIndex].PngRelativeUrlWithProduct = color.Image;
    //this.customizedProducts[productIndex].IsDefaultImageCustom = false;
    //this.customizedProducts[productIndex].DefaultImage = '';  
    var customizedProduct = this.customizedProducts[productIndex];
    // let color = customizedProduct.ColorList.find(x => x.StyleId == style.StyleId);
    for (var j = 0; j < customizedProduct.ColorList.length; j++) {
      if (customizedProduct.ColorList[j].StyleId == style.StyleId) {
        if (customizedProduct.IsWarehouseProduct) {
          // var ar = customizedProduct.DefaultImage.split('\\');
          // ar[3] = customizedProduct.ColorList[j].Image;
          // customizedProduct.DefaultImage = ar.join('\\');
        }
        else {
          // var newImg = customizedProduct.DefaultImage.split('/');
          // customizedProduct.DefaultImage = "/" + newImg[1] + "/" + newImg[2] + "/" + newImg[3] + "/" + newImg[4] + "/" + color.ColorName + "/" + newImg[6] + "/" + newImg[7] + "/" + newImg[8] + "/" + newImg[9] + "/" + newImg[10];
          
          this.fn_FetchImageToDisplay(style, customizedProduct);
        }
      }
    }
    // customizedProduct.IsDefaultImageCustom = false;

  }
  /** Function to GET list of customized product(s)*/
  fn_GetSavedDesignListing() {
    this.loader.show();
    this.filterModel.StoreName = this.storenameParam;
    console.log(this.filterModel);
    this.filterModel.ScreenPrint = this.screenPrint;
    this.filterModel.Embroidery = this.embroidery;
    this.inksoftService.getStorePublishProductList(this.filterModel).subscribe(
      (res: any) => {
        if (res.StatusCode === 200 && res.Message === 'Success') {
          localStorage.setItem('clientToken', res.Data.LoginResponseModel.BrainTreeToken);
          if (res.Data.ResponseData.length > 0) {
            this.length = res.Data.TotalDataCount;
            this.customizedProducts = [];
            res.Data.ResponseData.forEach((obj: any) => {
              //if product is from inksoft
              if (!obj.IsWarehouseProduct) {
                // check if item with same id exists
                if (!this.customizedProducts.find(x => x.CustomizedProductId === obj.CustomizedProductId)) {
                  
                let defaultStyle = obj.ColorList.find(c => c.Images.some(i => i.IsDefault));
                if (!defaultStyle)
                  defaultStyle = obj.ColorList[0];

                if (defaultStyle)
                  this.fn_FetchImageToDisplay(defaultStyle, obj);

                  this.productsCount = this.customizedProducts.push(obj);
                }
              } else {
                //if product is from warehouse product
                if (!this.customizedProducts.find(x => x.CustomizedProductId === obj.ProductId)) {
                  this.productsCount = this.customizedProducts.push(obj);
                }
              }
            });

            for (var i = 0; i < res.Data.ResponseData.length; i++) {
              if (!this.catListDB.find(x => x.ProductId === res.Data.ResponseData[i].ProductDescription[0].CategoryIds)) {
                var temp = res.Data.ResponseData[i].ProductDescription[0].CategoryIds;
                for (var j = 0; j < temp.length; j++) {
                  this.catListDB.push(temp[j]);
                }
              }
            }

          } else if (res.Data.ResponseData.length === 0) {
            this.filterModel.Skip = 0;
            this.fn_ResetProductList();
          }
        } else if (res.StatusCode === 404) {
          this.router.navigate(['/404NotFound']);
        }
        this.loader.hide();
      },
      (err: any) => {
        this.loader.hide();
      }
    );
  }

  fn_FetchImageToDisplay(style: ProductLibraryColorModel, obj: ProductLibraryModel) {
    let img = undefined;
    var imgObj = style.Images.sort(function (x, y) {
      // true values first
      return (x.IsDefault === y.IsDefault) ? 0 : x.IsDefault ? -1 : 1;
    })[0];
    if (imgObj) {
      if (imgObj.IsCustom)
        img = this.imgCustomBaseURL + imgObj.Image;
      else
        img = this.imgBaseURL + imgObj.Image;
    }
    obj['StyleId'] = style.StyleId;
    obj['Img'] = img;
    obj['ImgLoaded'] = false;
  }

  /**used for check null or empty */
  fn_CheckForNullUndefinedEmptyString(value: any) {
    if (value === null || value === '' || value === undefined) {
      return '';
    } else {
      return value;
    }
  }

  /**Redireect user to view store screen */
  fn_ViewProduct(productId: any, designId: any, type: number, index: any) {
    var product = this.customizedProducts[index];
    if (product.IsWarehouseProduct) {
      this.router.navigate([this.storenameParam + '/product/details'], {
        queryParams: { pid: product.EncryptedId, designId: 0, type: 2, IsShopifyProduct: 'false', IsSuperAdmin: 'false' }
      });
    }
    else {
      var encryptedproductId = this.EncrDecr.set(CryptoKeyValue.Key, String(productId))
      var encrypteddesignId = this.EncrDecr.set(CryptoKeyValue.Key, String(designId))
      this.router.navigate([this.storenameParam + '/product/details'], {
        queryParams: { pid: encryptedproductId, designId: encrypteddesignId, type: type, IsShopifyProduct: 'false', IsSuperAdmin: 'false' }
      });
    }
  }

  getProductImage(product: any): string {
    return this.designHuddleImageService.getProductThumbnailUrl(product);
  }

}
